export const c3contact = {

    /**
     * the class to add to the contact item, if it does not match the search phrase
     */
    hiddenClass: 'search-hidden',

    /**
     * the class to add to the list container, if no contacts match the search phrase
     */
    emptyClass: 'contact-list-empty',

    /**
     * initializes the contact search input. Parameters can be ignored, if the default class names are used for the
     * rendering
     * @param {HTMLInputElement} inputElement input element for contact filter
     * @param {HTMLElement[]} items contact items to filter
     * @param {HTMLElement} listContainer list container of the contact items
     */
    searchContacts({
        inputElement = document.querySelector('.contact-list .contact-list-search-input'),
        items = [...document.querySelectorAll('.contact-list .contact')],
        listContainer = document.querySelector('.contact-list')
    } = {}) {

        inputElement.addEventListener('input', () => {
            const searchString = inputElement.value.toLowerCase();

            // input is empty, show all items
            if (searchString === '') {
                items.forEach(item => item.classList.remove(this.hiddenClass));
                if (items.length) {
                    listContainer.classList.remove(this.emptyClass);
                }
                return;
            }

            let itemsFound = false;

            items.forEach(item => {
                const textContent = item.innerText.trim().toLowerCase();
                if (textContent.includes(searchString)) {
                    itemsFound = true;
                    this.onItemHide(item);
                } else {
                    this.onItemShow(item);
                }
            });

            listContainer.classList.toggle(this.emptyClass, !itemsFound);
        });
    },

    /**
     * gets executed, when an item gets hidden
     * @param {HTMLElement} item item to hide
     */
    onItemHide(item) {
        item.classList.remove(this.hiddenClass);
    },

    /**
     * gets executed, when an item gets shown
     * @param {HTMLElement} item item to show
     */
    onItemShow(item) {
        item.classList.add(this.hiddenClass);
    }
};